import { types } from "../../types/types";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import ContratacionesService from "../../services/ContratacionesService";

export const cleanCuentasContables = () => ({ type: types.contratacionesCuentasClean });

export const obtenerDatosContables = () => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      let response = null;

      response = await ContratacionesService.obtenerDatosBancarios(dataContrato.idEfectorFacturacion);
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.contratacionesSetearDatosContables,
          payload: body,
        });
      } else if (response.status === 404) {
        return;
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(dispatch, error, "Error al obtener datos contables", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};

export const obtenerDatosJudiciales = (setData) => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      const response = await ContratacionesService.obtenerDatosJudiciales(dataContrato.idEfectorFacturacion);
      if(response.status === 204) return;

      const body = await response.json();
      if (response.ok) {
        setData(body);
        // contratacionesDatosContablesActions.cuentaJudicial.get(setData(body), dispatch);
      } else if (response.status === 404) {
        return;
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(dispatch, error, "Error al obtener datos cuenta judicial", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};

export const guardarDatosJudiciales = (data, setData) => {
  return async (dispatch, getState) => {
    try {
      const response = await ContratacionesService.guardarCuentaJudicial({
        ...data,
        idEfectorFacturacion: getState().contrataciones.dataContrato.idEfectorFacturacion
      });
      const body = await response.json();
      if (response.ok) {
        setData(body);
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else if (response.status === 404) {
        return;
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(dispatch, error, "Error al guardar cuenta judicial", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};

export const guardarDatosContables = (datosContables) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      datosContables.idEfectorFacturacion = dataContrato.idEfectorFacturacion;
      let response = null;

      if (datosContables.idDatosBancarios === null) {
        response = await ContratacionesService.guardarDatosBancarios(datosContables)
      } else {
        response = await ContratacionesService.actualizarDatosBancarios(datosContables.idDatosBancarios, datosContables)
      }
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.contratacionesSetearDatosContables,
          payload: datosContables.idEfectorFacturacion === null ? body : datosContables,
        });
        dispatch(finishSpinner())
        if (datosContables.idDatosBancarios === null) {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        } else {
          dispatch(
            startAlerta(
              "Datos Editados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        }
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al guardar datos contables", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};

export const fetchBancos = () => async (dispatch) => {
  dispatch({ type: types.contratacionesTraerBancosStart });
  try {
    const result = await ContratacionesService.traerBancos()
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesTraerBancosSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesTraerBancosError });
    handleErrorApi(dispatch, error, "Error al obtener bancos", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchCategoriasEfectores = () => async (dispatch) => {
  dispatch({ type: types.contratacionesTraerCategoriasStart });
  try {
    const result = await ContratacionesService.traerTodasCategoriasEfector();
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesTraerCategoriasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesTraerCategoriasError });
    handleErrorApi(dispatch, error, "Error al obtener categorias de efector", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchCondicionIva = () => async (dispatch) => {
  dispatch({ type: types.contratacionIvaTraerStart });
  try {
    const result = await ContratacionesService.traerCondicionIva();
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionIvaTraerSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionIvaTraerError });
    handleErrorApi(dispatch, error, "Error al obtener condiciones de IVA", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchCuentasContables = () => 
async (dispatch, getState) => {
  dispatch({ type: types.contratacionesTraerCuentasStart });
  try {
    const { dataContrato } = getState().contrataciones;
    const result = await ContratacionesService.obtenerCuentasContables(dataContrato.idEfectorFacturacion);
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesTraerCuentasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesTraerCuentasError });
    handleErrorApi(dispatch, error, "Error al obtener cuentas contables", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const postCuentasContables = (data, setOpen) => 
async (dispatch) => {
  try {
    dispatch(startSpinner());
    const result = await ContratacionesService.guardarCuentasContables(data);
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesCuentasGuardar,
        payload: body,
      });
      dispatch(startAlerta(
        "Datos Guardados Exitosamente",
        "success",
        "Comando Exitoso"
      ));
      dispatch(finishSpinner());
      setOpen(false);
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(dispatch, error, "Error al guardar cuenta contable", "Ha ocurrido un error. Intente nuevamente");
    dispatch(finishSpinner());
  }
};

export const updateCuentasContables = (data) => 
async (dispatch) => {
  try {
    dispatch(startSpinner());
    const result = await ContratacionesService.actualizarCuentasContables(data);
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesCuentasActualizar,
        payload: body,
      });
      dispatch(startAlerta(
        "Cuenta Actualizada Exitosamente",
        "success",
        "Comando Exitoso"
      ));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(dispatch, error, "Error al actualizar cuenta contable", "Ha ocurrido un error. Intente nuevamente");
    dispatch(finishSpinner());
  }
};

export const deleteCuentasContables = (id) => 
async (dispatch) => {
  try {
    dispatch(startSpinner());
    const result = await ContratacionesService.deleteCuentasContables(id);
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesCuentasEliminar,
        payload: id,
      });
      dispatch(startAlerta(
        "Cuenta Eliminada Exitosamente",
        "success",
        "Comando Exitoso"
      ));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(dispatch, error, "Error al eliminar cuenta contable", "Ha ocurrido un error. Intente nuevamente");
    dispatch(finishSpinner());
  }
};
